import * as Sentry from '@sentry/nuxt'
import type { SessionJwt } from '@xleddyl/types'
import { jwtDecode } from 'jwt-decode'

export default defineNuxtPlugin(() => {
   const client = useSupabaseClient()

   client.auth.onAuthStateChange((_, session) => {
      const token = session?.access_token

      if (!token) {
         Sentry.setUser(null)
         return
      }

      const { user_details } = jwtDecode<SessionJwt>(token)

      Sentry.setUser(user_details ? { id: user_details.id, email: user_details.email } : null)
   })
})
